import script from "./chooseMoreImg.vue?vue&type=script&setup=true&lang=js"
export * from "./chooseMoreImg.vue?vue&type=script&setup=true&lang=js"

import "./chooseMoreImg.vue?vue&type=style&index=0&id=412155b7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-412155b7"]])

export default __exports__